import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Stack, Typography } from '@mui/material';
import { PromptDialogOnSide } from 'common/components/PromptDialogOnSide/PromptDialogOnSide';
import { styles } from 'common/components/PromptDialogOnSide/PromptDialogOnSide.styles';
import { FormInput } from 'common/form/components/FormInput';
import { fieldIsRequiredValidator } from 'common/form/validators';
import { DialogComponentProps } from 'common/hooks/useDialog';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

interface FormValues {
  text?: string | null;
}

export interface EditFinancialReserveTextDialogProps extends DialogComponentProps<string | undefined | null> {
  text?: string | null;
}

export const EditFinancialReserveTextDialog: React.FC<EditFinancialReserveTextDialogProps> = ({
  isOpen,
  onReject,
  onResolve,
  text,
}) => {
  const { t } = useTranslation();

  const schema: yup.SchemaOf<FormValues> = yup.object({
    text: fieldIsRequiredValidator(),
  });

  const formMethods = useForm<FormValues>({
    defaultValues: {
      text,
    } as FormValues,
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(schema),
  });

  const handleSubmit = formMethods.handleSubmit(async (data) => {
    onResolve(data.text);
  });

  return (
    <PromptDialogOnSide
      onClose={() => onReject()}
      open={isOpen}
      title={t('fintelligenceReport.editFinancialReserveTextDialog.title')}
    >
      <FormProvider {...formMethods}>
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Box>
            <FormInput autoComplete="text" autoFocus fullWidth name="text" type="text" />
          </Box>

          <Stack mt={3} spacing={1}>
            <Button color="primary" sx={styles.button} type="submit">
              <Typography color="white" variant="bodyL">
                {t('fintelligenceReport.editFinancialReserveTextDialog.save')}
              </Typography>
            </Button>
            <Button color="tertiaryButton" onClick={() => onReject()} sx={styles.button}>
              <Typography color="blue.dark" variant="bodyL">
                {t('common:cancel')}
              </Typography>
            </Button>
          </Stack>
        </Box>
      </FormProvider>
    </PromptDialogOnSide>
  );
};
